module.exports = __webpack_public_path__ + "static/media/angrycreative.f3048fd4.svg";